/**
 * Created by pli on 26/05/16.
 */
angular.module('taric.duty.calculate.doc', ['taric.model.cd', 'common.template.footnote.popup'])
    .controller('CalculateDutyDocCtrl', function (CalculateDutyModel, CONSTANTS, $uibModal) {
    var docCtrl = this;
    docCtrl.init = function () {
        docCtrl.dateFormat = CONSTANTS.dateFormat;
        docCtrl.calculationInput = CalculateDutyModel.getCalculationInput();
        docCtrl.documents = CalculateDutyModel.getDocuments().items;
        docCtrl.installationCountry = CONSTANTS.installationCountry;
        docCtrl.initDocuments();
        // Backing data model for view
        docCtrl.model = CalculateDutyModel;        
    };

    docCtrl.updateError = function(error) {
        if (!error){
            docCtrl.errorCode = null;
            docCtrl.errorParams = null;
            docCtrl.errorType = null;
        } else {
            docCtrl.errorCode = error.data.code;
            docCtrl.errorParams = error.data.params;
            docCtrl.errorType = error.data.errorType;
        }
    };

    docCtrl.initDocuments = function () {
        docCtrl.initDocuments = [];
        docCtrl.documents.forEach(function(group) {
            if (group){
                docCtrl.initDocuments.push(group);
            }
        });
    };

    docCtrl.updateCalculationInput = function() {
        docCtrl.calculationInput.documents = [];
        for (let i = 0; i < docCtrl.initDocuments.length; i++) {
            var item = docCtrl.initDocuments[i];
            for (let j = 0; j < item.documentConditionGroups.length; j++) {
                if (item.documentConditionGroups[j].selectedDocument) {

                    // AA-950: a selectedDocument needs to be combined of MesureTypeId, MeasureConditionCode, and DocumentId (CertificateType + CertificateCode) to be unique.
                    docCtrl.calculationInput.documents.push(item.type.id +
                            "_" + item.documentConditionGroups[j].code +
                            "_" + item.documentConditionGroups[j].selectedDocument);
                }
            }
        }
    };

    docCtrl.validateForm = function () {
        docCtrl.updateError(null);
        var valid = true;
        for (let i = 0; i < docCtrl.initDocuments.length; i++) {
            var item = docCtrl.initDocuments[i];
            for (let j = 0; j < item.documentConditionGroups.length; j++) {
        if (item.documentConditionGroups[j].selectedDocument === undefined ||
            item.documentConditionGroups[j].selectedDocument === null) {
                    docCtrl.errorCode = "i8n.qry.cd.qryCalcDutiesBean.document.noselection";
                    valid = false;
                }
            }
        }
        return valid;
    };

    docCtrl.next = function () {
        var valid = docCtrl.validateForm();
        if (valid) {
            docCtrl.updateCalculationInput();
            docCtrl.navigatingToNextTab = true;
            CalculateDutyModel.goToNextTab('documents').then(function(){
                docCtrl.navigatingToNextTab = false;
            }, function (error) {
                docCtrl.errorCode = error.data.code;
                docCtrl.errorParams = error.data.params;
                docCtrl.errorType = error.data.errorType;
                docCtrl.navigatingToNextTab = false;
            });
        }
    };

    docCtrl.openFootnotePopup = function (size, footnoteId) {
        $uibModal.open({
            animation: true,
            templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
            controller: 'FootnotePopupController as footnotePopupCtrl',
            size: size,
            resolve: {
                footnote: function (FootnotePopupModel) {
                    return FootnotePopupModel.findFootnote(footnoteId, docCtrl.calculationInput.simulationDate);
                }
            }
        });
    };

    docCtrl.selectDocument = function(selectedDocument) {
        // AA-967 When a document is selected, the same document in a different group must be selected automatically.
        if (!selectedDocument) {
            return;
        }

        // Loop through document groups
        for (let i = 0; i < docCtrl.initDocuments.length; i++) {
            var item = docCtrl.initDocuments[i];
            for (let j = 0; j < item.documentConditionGroups.length; j++) {
                var group = item.documentConditionGroups[j];

                // If the group's selectedDocument is different from selectedDocument,
                // loop through its documents to select the same document.
                if (group.selectedDocument !== selectedDocument) {
                    for (let k = 0; k < group.documents.length; k++) {
                        if (group.documents[k].document.id === selectedDocument) {
                            group.selectedDocument = selectedDocument;
                            break;
                        }
                    }
                }

                // If the group is selected the same document, check the next group.
                if (group.selectedDocument === selectedDocument) {
                    break;
                }
            }
        }
    };

});



// WEBPACK FOOTER //
// ./app/taric/duties/calculate/documents/cd-documents.js